module.exports = __webpack_public_path__ + "img/P4-1.fdded814.jpg";